import { Button } from "@/components/ui/button";
import { Sparkles, RotateCw } from "lucide-react";

export function ReceiptImagePanel({ previewSrc, step, isEdit, onChangeImage }) {
  return (
    <div className="md:col-span-5 md:sticky md:top-32">
      <div className="border border-border bg-card p-3">
        <div className="data-label mb-2 px-1">Originalbeleg</div>
        <div className="scan-wrap border border-border bg-muted rounded-sm flex items-center justify-center min-h-[320px]">
          {previewSrc ? (
            <img
              src={previewSrc}
              alt="Beleg"
              className="w-full h-auto max-h-[70vh] object-contain"
              data-testid="receipt-preview"
            />
          ) : (
            <div className="text-muted-foreground text-sm py-20">Kein Bild</div>
          )}
          {step === "extracting" && (
            <>
              <div className="scan-beam" />
              <div className="scan-line" />
              <div className="absolute inset-0 flex items-end justify-center pb-6 pointer-events-none">
                <div className="bg-foreground/85 text-background text-sm font-medium px-4 py-2 rounded-md flex items-center gap-2">
                  <Sparkles className="h-4 w-4 animate-pulse" />
                  Beleg wird ausgelesen…
                </div>
              </div>
            </>
          )}
        </div>
        {!isEdit && (
          <Button
            variant="ghost"
            size="sm"
            tabIndex={-1}
            className="mt-2 gap-2 text-muted-foreground"
            onClick={onChangeImage}
            data-testid="change-image-button"
          >
            <RotateCw className="h-3.5 w-3.5" /> Anderes Bild wählen
          </Button>
        )}
      </div>
    </div>
  );
}
